// extracted by mini-css-extract-plugin
export default {"message":"yqz4Y","title":"k0lfh","icon":"m0BKA","text":"rakLo"};